import { Instagram, Facebook, Phone, Mail } from "lucide-react";

const CONTACT = {
  phone: "0458 792 779",
  phoneRaw: "+61458792779",
  email: "trainwithc2c@gmail.com",
  instagram: {
    handle: "@coast2coastbasketballacademy",
    url: "https://instagram.com/coast2coastbasketballacademy",
  },
  facebook: {
    handle: "C2CBasketballAcademy",
    url: "https://facebook.com/C2CBasketballAcademy",
  },
};

export { CONTACT };

export const Footer = () => (
  <footer className="relative border-t border-white/10 bg-[#060b14] px-6 md:px-12 py-16">
    <div className="max-w-[1600px] mx-auto grid grid-cols-12 gap-x-8 gap-y-12">
      <div className="col-span-12 md:col-span-5 lg:col-span-4">
        <div className="flex items-center gap-4">
          <img
            src="https://customer-assets-39nsmqrw.emergentagent.net/job_59d46705-6dcb-49ae-8336-02ffaa8344ff/artifacts/ehbe4kg0_ChatGPT%20Image%20Jul%2024%2C%202026%2C%2008_44_18%20PM.png"
            alt="Coast 2 Coast Basketball Academy"
            className="h-16 w-16 md:h-20 md:w-20 object-cover border border-white/10"
          />
          <div className="font-display uppercase text-3xl md:text-4xl leading-[0.85] tracking-tight">
            Coast<span className="text-[#2a5fdb]">2</span>Coast
          </div>
        </div>
        <p className="mt-6 max-w-sm text-white/55 text-sm leading-relaxed">
          A private basketball academy for the Eastern Suburbs of Sydney.
          Built by a coach who&apos;s still on the court every week.
        </p>

        <div className="mt-8 flex items-center gap-3">
          <a
            href={CONTACT.instagram.url}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
            data-testid="social-instagram"
            className="h-11 w-11 flex items-center justify-center border border-white/15 text-white/70 hover:text-white hover:border-white hover:bg-white/[0.04] transition-all"
          >
            <Instagram size={18} strokeWidth={1.5} />
          </a>
          <a
            href={CONTACT.facebook.url}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook"
            data-testid="social-facebook"
            className="h-11 w-11 flex items-center justify-center border border-white/15 text-white/70 hover:text-white hover:border-white hover:bg-white/[0.04] transition-all"
          >
            <Facebook size={18} strokeWidth={1.5} />
          </a>
          <a
            href={`tel:${CONTACT.phoneRaw}`}
            aria-label="Call"
            data-testid="social-phone"
            className="h-11 w-11 flex items-center justify-center border border-white/15 text-white/70 hover:text-white hover:border-white hover:bg-white/[0.04] transition-all"
          >
            <Phone size={18} strokeWidth={1.5} />
          </a>
          <a
            href={`mailto:${CONTACT.email}`}
            aria-label="Email"
            data-testid="social-email"
            className="h-11 w-11 flex items-center justify-center border border-white/15 text-white/70 hover:text-white hover:border-white hover:bg-white/[0.04] transition-all"
          >
            <Mail size={18} strokeWidth={1.5} />
          </a>
        </div>
      </div>

      <div className="col-span-6 md:col-span-3 lg:col-span-3 flex flex-col gap-3 font-mono text-[11px] uppercase tracking-[0.2em]">
        <div className="text-white/45">Navigate</div>
        <a href="#about" className="text-white/85 hover:text-white link-underline w-fit">
          About
        </a>
        <a
          href="#philosophy"
          className="text-white/85 hover:text-white link-underline w-fit"
        >
          Philosophy
        </a>
        <a
          href="#programs"
          className="text-white/85 hover:text-white link-underline w-fit"
        >
          Programs
        </a>
        <a
          href="#testimonials"
          className="text-white/85 hover:text-white link-underline w-fit"
        >
          Testimonials
        </a>
        <a
          href="#contact"
          className="text-white/85 hover:text-white link-underline w-fit"
        >
          Contact
        </a>
      </div>

      <div className="col-span-6 md:col-span-4 lg:col-span-5 flex flex-col gap-4 font-mono text-[11px] uppercase tracking-[0.2em]">
        <div className="text-white/45">Get in touch</div>
        <a
          href={`tel:${CONTACT.phoneRaw}`}
          data-testid="footer-phone"
          className="text-white/85 hover:text-white link-underline normal-case tracking-normal font-sans text-sm w-fit"
        >
          {CONTACT.phone}
        </a>
        <a
          href={`mailto:${CONTACT.email}`}
          data-testid="footer-email"
          className="text-white/85 hover:text-white link-underline normal-case tracking-normal font-sans text-sm w-fit break-all"
        >
          {CONTACT.email}
        </a>
        <a
          href={CONTACT.instagram.url}
          target="_blank"
          rel="noopener noreferrer"
          className="text-white/85 hover:text-white link-underline normal-case tracking-normal font-sans text-sm w-fit break-all"
        >
          {CONTACT.instagram.handle}
        </a>
        <a
          href={CONTACT.facebook.url}
          target="_blank"
          rel="noopener noreferrer"
          className="text-white/85 hover:text-white link-underline normal-case tracking-normal font-sans text-sm w-fit break-all"
        >
          {CONTACT.facebook.handle}
        </a>
      </div>

      <div className="col-span-12 mt-8 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 font-mono text-[10px] uppercase tracking-[0.3em] text-white/40">
        <span>© 2026 Coast 2 Coast Basketball Academy · Owen Levy</span>
        <span>Made in Sydney · Ball is life</span>
      </div>
    </div>
  </footer>
);
